import styled from 'styled-components';

export const IdleRecommendationHeaderTitleWrapperBox = styled.div`
    // from cgp-theme-property-font-type-3
    font-family: ${({theme}) => theme.font.family.body};
    // from cgp-theme-property-text-align
    text-align: center;
`;
